// extracted by mini-css-extract-plugin
module.exports = {"linkSeo":"index_linkSeo__N4ovM"};